
<template>
    <div :class="['privilege-compare', vipInfo.vipStatusName]">
        <div class="table-title">会员权益明细对比</div>
        <div :class="['compare-table', compareTableType]">
            <div
                v-for="(item, index1) in list"
                :key="index1"
                class="row"
            >
                <div
                    v-for="(subItem, index2) in item"
                    :key="index2"
                    :class="[
                        'column',
                        index1 === 0 ? 'header' : '',
                        index1 === list.length - 1 ? 'last-line' : '',
                        index1 !== 0 && index2 === 0 ? 'fisrt-column' : '',
                        index2 === item.length - 1 ? 'last-column' : '',
                        index2 === 0 ? vipInfo.vipStatusName + '-fisrt-column-width' : '',
                        (+vipInfo.vipStatus && vipInfo.vipStatusName === 'beginnerVip')
                            ? (index2 === 0 ? 'young-vip-column-1' : '')
                            : (index2 === 0 ? 'not-young-vip-column-1' : ''),
                    ]"
                    :style="{
                        background: !(fontList[index2] && fontList[index2].isSelect)
                            && colorList[index1 % 2] && colorList[index1 % 2][index2] || '',
                        color: fontList[index2] && fontList[index2].color,
                        fontWeight: fontList[index2] && fontList[index2].fontWeight || 400,
                        borderColor: vipInfo.vipStatusName && strokeStyle[vipInfo.vipStatusName] || strokeStyle.default,
                    }"
                >
                    <!-- 特殊容器样式-走定位模式 -->
                    <template
                        v-if="fontList[index2] && fontList[index2].isSelect"
                    >
                        <div
                            :class="[
                                'specail-box',
                                index1 === 0 && fontList[index2] && fontList[index2].isSelect ? 'first-box' : '',
                                index1 === list.length - 1
                                    && fontList[index2] && fontList[index2].isSelect ? 'last-box' : '',
                            ]"
                            :style="{
                                background: colorList[index1 % 2] && colorList[index1 % 2][index2],
                                color: fontList[index2].color,
                                borderColor: vipInfo.vipStatusName && strokeStyle[vipInfo.vipStatusName]
                                    || strokeStyle.default,
                            }"
                        >
                            <img
                                v-if="subItem.src"
                                :src="subItem.src"
                                class="icon"
                            />
                            <div v-if="subItem.value">{{ subItem.value }}</div>
                            <img
                                v-if="!subItem.value && !subItem.src"
                                src="https://lvlin-base.bj.bcebos.com/fe-saas/page/account/false.png"
                                class="false"
                            />
                        </div>
                    </template>
                    <template
                        v-else
                    >
                        <img
                            v-if="subItem.src"
                            :src="subItem.src"
                            class="icon"
                        />
                        <div v-if="subItem.value">{{ subItem.value }}</div>
                        <img
                            v-if="!subItem.value && !subItem.src"
                            src="https://lvlin-base.bj.bcebos.com/fe-saas/page/account/false.png"
                            class="false"
                        />
                    </template>
                </div>
            </div>
        </div>
        <div class="button" @click.stop="handleAuthorize">
            授权客服电联，了解更多会员权益
        </div>
    </div>
</template>
<script>
/**
 * @desc 权益列表
 * @author <xingminghua@baidu.com>
 */

import tableList from '../table';
export default {
    props: {
        vipInfo: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            compareTableType: '', // 权益对比列表类型
            list: [],
            colorList: [],
            fontList: [],
            strokeStyle: {
                beginnerVip: 'rgba(202, 220, 253, .8)',
                eliteVip: 'rgba(202, 220, 253, .8)',
                freeVip: '#FFE2CD',
                vip: '#FFE2CD',
                default: '#EDF1F8'
            }
        };
    },
    mounted() {
        this.initCompareList();
    },
    methods: {
        handleAuthorize() {
            this.$emit('onAuthorize');
        },
        initCompareList() {
            const {beginnerVipList,
                   beginnerColorList,
                   beginnerFontList,
                   eliteVipList,
                   eliteColorList,
                   eliteFontList,
                   vipList,
                   vipColorList,
                   vipFontList,
                   freeVipList,
                   freeColorList,
                   freeFontList,
                   outVipList,
                   outColorList,
                   outFontList,
                   noVipList,
                   noColorList,
                   noFontList
            } = tableList;
            let compareTableType = '';
            if (
                +this.vipInfo.vipStatus
                && this.vipInfo.vipStatusName === 'beginnerVip'
            ) {
                compareTableType = 'beginner-vip';
                this.list = beginnerVipList;
                this.colorList = beginnerColorList;
                this.fontList = beginnerFontList;
            }
            else if (
                +this.vipInfo.vipStatus
                && this.vipInfo.vipStatusName === 'freeVip'
            ) {
                compareTableType = 'free-vip';
                this.list = freeVipList;
                this.colorList = freeColorList;
                this.fontList = freeFontList;
            }
            else if (
                +this.vipInfo.vipStatus
                && this.vipInfo.vipStatusName === 'eliteVip'
            ) {
                compareTableType = 'elite-vip';
                this.list = eliteVipList;
                this.colorList = eliteColorList;
                this.fontList = eliteFontList;
            }
            else if (
                +this.vipInfo.vipStatus
                && this.vipInfo.vipStatusName === 'vip'
            ) {
                compareTableType = 'vip';
                this.list = vipList;
                this.colorList = vipColorList;
                this.fontList = vipFontList;
            }
            else if (
                (+this.vipInfo.vipStatus
                    && this.vipInfo.vipStatusName === 'vcardVip')
                || !this.vipInfo.vipStatus
            ) {
                compareTableType = 'v-card-vip';
                this.list = noVipList;
                this.colorList = noColorList;
                this.fontList = noFontList;
            }
            else if (this.vipInfo.canReceiveFreeVip) {
                compareTableType = 'no-vip';
                this.list = noVipList;
                this.colorList = noColorList;
                this.fontList = noFontList;
            }
            else {
                compareTableType = 'no-vip-no-free-vip';
                this.list = outVipList;
                this.colorList = outColorList;
                this.fontList = outFontList;
            }

            this.compareTableType = compareTableType;
        }
    }
};
</script>
<style lang="less" scoped>
.privilege-compare {
    margin-top: 30px;

    .title {
        margin: auto;
        width: max-content;
        height: 40px;
        min-width: 600px;
        text-align: center;
        padding: 0 118px;
        background:


            url(https://lvlin-base.cdn.bcebos.com/fe-saas/page/law-info/vip-title-bg.png)
            no-repeat center / contain;
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        color: #333;
        line-height: 40px;
        font-weight: 600;
        margin-bottom: 24px;

        .highlight {
            color: #9a490e;
        }
    }

    .button {
        cursor: pointer;
        margin: 61px auto 0;
        padding: 12px 0;
        width: 326px;
        height: 48px;
        background-color: #05f;
        border-radius: 5px;
        font-family: PingFangSC-Medium;
        font-size: 18px;
        line-height: 24px;
        color: #fff;
        text-align: center;
        font-weight: 500;

        &:hover {
            opacity: .8;
        }
    }

    .table-title {
        margin: 30px 0 42px 0;
        color: #000;
        font-family: PingFang SC;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 18px;
    }

    .compare-table {
        width: 100%;
        border-left: 1px solid #e9f1fd;
        border-bottom: 1px solid #e9f1fd;
        border-radius: 18px;

        .row {
            display: flex;

            .column {
                flex: 1;
                position: relative;
                padding: 16px 33px;
                display: flex;
                justify-content: center;
                align-items: center;
                text-align: center;
                // box-sizing: border-box;
                font-family: "PingFang SC";
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: 22px;

                &.young-vip-column-1 {
                    flex: 0 0 212px;
                }

                &.not-young-vip-column-1 {
                    flex: 0 0 176px;
                    // width: 176px;
                }

                &.header {
                    height: 65px;
                    color: #1e1f24;
                    font-family: "PingFang SC";
                    font-size: 18px;
                    font-style: normal;
                    font-weight: 600 !important;
                    line-height: 18px;

                    &:first-child {
                        border-top-left-radius: 18px;
                        border-top: 1px solid #e9f1fd !important;
                    }

                    &.last-column {
                        border: none !important;
                        border-top-right-radius: 18px;
                    }

                    .specail-box {
                        border-top-style: solid;
                        border-top-width: 2px;
                        height: 77px;
                    }
                }

                &.last-line {
                    &:first-child {
                        border-bottom-left-radius: 18px;
                    }

                    &.last-column {
                        border: none !important;
                    }

                    .specail-box {
                        height: 135%;
                        border-bottom-style: solid;
                        border-bottom-width: 2px;
                    }
                }

                &.fisrt-column {
                    color: #1e1f24;
                    font-family: "PingFang SC";
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 24px;
                }

                .icon {
                    width: 24px;
                    margin-right: 6px;
                }

                .false {
                    width: 20px;
                }

                .specail-box {
                    position: absolute;
                    z-index: 1;
                    width: 100%;
                    padding: 0 33px;
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border-left-style: solid;
                    border-right-style: solid;
                    box-sizing: border-box;
                    border-left-width: 2px;
                    border-right-width: 2px;

                    &.first-box {
                        border-radius: 18px 18px 0 0;
                        bottom: 0;
                    }

                    &.last-box {
                        top: 0;
                        border-radius: 0 0 18px 18px;
                    }
                }
            }

            .beginnerVip-fisrt-column-width,
            .vip-fisrt-column-width,
            .eliteVip-fisrt-column-width {
                min-width: 230px;
            }
        }
    }

    &.beginnerVip {
        .title {
            background-image: url(https://lvlin-base.cdn.bcebos.com/fe-saas/page/law-info/beginner-vip-title-bg.png);
        }

        .button {
            background: #05f;
            color: #fff;
        }
    }

    &.noVip {
        .title {
            background-image: url(https://lvlin-base.cdn.bcebos.com/fe-saas/page/law-info/no-vip-title-bg.png);
        }

        .button {
            background: #05f;
            color: #fff;
        }
    }

    &.freeVip,
    &.vip {
        .button {
            background: #fed9b9;
            color: #401611;
        }
    }
}
</style>
